import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import relaciones from './modules/relaciones'

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    relaciones,
  }
})
